import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"wrap":"","justify-center":""}},_vm._l((_vm.infoBlocks),function(blockInfo,idx){return _c('block-info-element',{key:idx,ref:_vm.getHref(idx),refInFor:true,attrs:{"p_blockInfo":blockInfo,"p_isExpanded":_vm.hasExpanded(idx)},on:{"expandCard":function($event){return _vm.expandCard(idx, true)},"collapseCard":function($event){return _vm.expandCard(idx, false)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }